<template>
  <div>
    <PCNavbar selectIndex="1"/>
    <MobileNavBar :currentActive="0"/>
    <CarouselHome />
    <TodoShow/>
    <!-- <CompanyIntro /> -->

    <!-- <CooperationCustomer/> -->
    <!-- <CoreCompetence/> -->
    <!-- <Privacy/> -->
    <!-- <coreValues/> -->
    <!-- <NewsInfomation/> -->
    <CallMe/>
    <MobileCallme/>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CarouselHome from '@/components/carousel_home/index'
import TodoShow from '@/components/todo_show/index'
import redcHome from '@/components/redc_home/index'
import CoreCompetence from '@/components/core_competence/index'
import CompanyIntro from '@/components/company_intro/index'
import Privacy from '@/components/privacy/index'
import coreValues from '@/components/core_values/index'
import CooperationCustomer from '@/components/cooperation_customer/index'
import NewsInfomation from '@/components/news_infomation/index'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome,
    TodoShow,
    redcHome,
    CoreCompetence,
    CompanyIntro,
    Privacy,
    coreValues,
    CooperationCustomer,
    NewsInfomation,
    CallMe,
    MobileCallme
  },
}
</script>

<style lang="scss" scoped>

</style>